import "./src/styles/global.css";
import { wrapRootElement as wrap } from "./src/components/WrapRootElement";

export const wrapRootElement = wrap;
